import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { token, user, checking } = useAuth();
  const location = useLocation();

  if (checking) return <div className="min-h-screen grid place-items-center bg-sky-soft font-hand text-xl text-[#2b8b98]">Memeriksa sesi...</div>;
  if (!token) return <Navigate to="/login" replace state={{ from: location }} />;
  if (user?.role !== 'admin') return <Navigate to="/akses-terbatas" replace />;
  return children;
};

export default ProtectedRoute;
